var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagonAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3406 26L0 19.4458V6.35403L10.7152 0.16673C11.3156 -0.175156 12.0744 0.0249721 12.4246 0.625357C12.7749 1.22574 12.5664 1.98456 11.966 2.33479L2.5016 7.79662V18.0032L11.3406 23.1064L20.805 17.6446C21.4054 17.2944 22.1642 17.5028 22.5144 18.1032C22.8563 18.7036 22.6562 19.4624 22.0558 19.8127L11.3406 26Z",
    fill: "#E75074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1617 1.94287C14.2342 1.94287 11.0488 5.12825 11.0488 9.05576C11.0488 12.9833 14.2342 16.1687 18.1617 16.1687C22.0892 16.1687 25.2746 12.9833 25.2746 9.05576C25.2746 5.12825 22.0892 1.94287 18.1617 1.94287ZM21.7974 9.76455H18.8705V12.6914C18.8705 13.0833 18.5536 13.4002 18.1617 13.4002C17.7698 13.4002 17.4529 13.0833 17.4529 12.6914V9.76455H14.5261C14.1341 9.76455 13.8173 9.44768 13.8173 9.05576C13.8173 8.66385 14.1341 8.34698 14.5261 8.34698H17.4529V5.4201C17.4529 5.02818 17.7698 4.71131 18.1617 4.71131C18.5536 4.71131 18.8705 5.02818 18.8705 5.4201V8.34698H21.7974C22.1893 8.34698 22.5062 8.66385 22.5062 9.05576C22.5062 9.44768 22.1893 9.76455 21.7974 9.76455Z",
    fill: "#E75074"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2745,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonAdd);
export default __webpack_public_path__ + "static/media/hexagon-add.5bc9de6ba8cba53af4c99f8602e8ee51.svg";
export { ForwardRef as ReactComponent };